import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  untracked,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  ILegalTexts,
  WhitelabelImage,
  WhitelabelImageAltTag,
  WhitelabelImageType,
} from '@resident-nx/shared';
import { FormFieldComponent } from '../../../molecules/form/form-field.component';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { WhitelabelImageWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  selector: 'rs-web-consent-documents',
  standalone: true,
  templateUrl: './consent-documents.component.html',
  styleUrls: ['../shared/consent-page-base.scss', './consent-documents.component.scss'],
  imports: [
    ImmomioButtonComponent,
    TranslateModule,
    WhitelabelImageWebComponent,
    FormFieldComponent,
    ReactiveFormsModule,
    RouterLink,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsentDocumentsWebComponent {
  readonly WhitelabelImage = WhitelabelImage;
  readonly WhitelabelImageAltTag = WhitelabelImageAltTag;
  readonly WhitelabelImageType = WhitelabelImageType;
  readonly control = new FormControl(false);
  readonly legalTexts = input.required<ILegalTexts>();
  readonly isLoading = input.required<boolean>();
  readonly acceptConsent = output<{ legalTextId: string; consentGiven: boolean }>();

  constructor() {
    this.setValidatorsEffect();
    this.disableControlEffect();
  }

  setValidatorsEffect() {
    return effect(() => {
      const legalTexts = this.legalTexts();
      if (legalTexts?.digitalDocumentsReceivalMandatory) {
        untracked(() => {
          this.control.setValidators([Validators.requiredTrue]);
          this.control.updateValueAndValidity({ emitEvent: false });
        });
      }
    });
  }

  disableControlEffect() {
    return effect(() => {
      const isLoading = this.isLoading();
      untracked(() => {
        if (isLoading) {
          this.control.disable({ emitEvent: false });
        } else {
          this.control.enable({ emitEvent: false });
        }
      });
    });
  }
}
